import { ICustomBinding } from "#/DefaultViewExtensionInterfaces";

export default class StylesBinding implements ICustomBinding {

    public initBinding() {
        ko.bindingHandlers.styles = {
            update: (node: HTMLElement, valueAccessor: () => any) => {
                let element = $(node);
                let value = valueAccessor();
                let styles = ko.unwrap(value);

                (element as any).alterClass('c-style-*');

                for (let i = 0; i < styles.length; i++) {
                    element.addClass('c-style-' + styles[i]);
                }
            }
        };
    }
}